import Modal from "./modal.js";
import { createElement } from "./dom_utils.js";

class VideoPreviewModal {
  constructor() {
    this.modal = new Modal();
  }

  open(videoUrl) {
    const container = createElement("div", {
      style: `
        width: 90vw;
        max-width: 800px;
        height: auto;
        aspect-ratio: 16 / 9;
        max-height: 80vh;
        position: relative;
        border-radius: 8px;
        overflow: hidden;
        padding: 24px;
      `,
    });

    const video = createElement("video", {
      src: videoUrl,
      controls: true,
      autoplay: true,
      style:
        "width: 100%; height: 100%; object-fit: contain; border-radius: 8px;",
    });

    const source = createElement("source", {
      src: videoUrl,
      type: "video/mp4",
    });

    video.appendChild(source);
    container.appendChild(video);
    this.modal.open(container);
  }

  close() {
    this.modal.close();
  }
}

export default VideoPreviewModal;
